module.exports = __webpack_public_path__ + "static/media/clock_price.283ff43d.svg";